var exports = {
  "kL": "xdbfd91f1--f1ff65--container",
  "h_": "xdbfd91f1--f1ff65--description",
  "DD": "xdbfd91f1--f1ff65--title",
  "Kk": "xdbfd91f1--f1ff65--icon",
  "W2": "xdbfd91f1--f1ff65--scroll",
  "UE": "xdbfd91f1--f1ff65--arrow",
  "N4": "xdbfd91f1--f1ff65--feature",
  "ph": "xdbfd91f1--f1ff65--icon--default",
};

module.exports = exports;
